import { useQueryClient } from "@tanstack/react-query";

import { View, ViewQueryParams } from "@/types";

export const useRemoveView = () => {
  const queryClient = useQueryClient();

  return ({
    id,
    viewQueryParams,
  }: {
    id: number;
    viewQueryParams: ViewQueryParams;
  }) => {
    queryClient.setQueryData(
      ["views", viewQueryParams],
      (cachedViews: View[]) => cachedViews.filter((v) => v.id !== id),
    );
  };
};
